import { render, staticRenderFns } from "./products-select-list.vue?vue&type=template&id=55de6d63&"
import script from "./products-select-list.vue?vue&type=script&lang=js&"
export * from "./products-select-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports